import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTheme } from '../context/ThemeContext';
import ToolsPanel from './ToolsPanel';
import { RyzenMark } from './RyzenLogo';
import './Sidebar.css';

const ICONS = {
  dashboard: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/></svg>,
  leads: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>,
  clients: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/><line x1="12" y1="12" x2="12" y2="16"/><line x1="10" y1="14" x2="14" y2="14"/></svg>,
  finance: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>,
  projects: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>,
  calendar: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>,
  analytics: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg>,
  team: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M4 20c0-4 3.6-7 8-7s8 3 8 7"/></svg>,
  files: <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/></svg>,
};

const NAV = [
  { section: 'MAIN' },
  { label:'Dashboard', path:'/dashboard', icon: ICONS.dashboard },
  { section: 'CRM' },
  { label:'Leads',     path:'/leads',     icon: ICONS.leads },
  { label:'Clients',   path:'/clients',   icon: ICONS.clients },
  { label:'Finance',   path:'/finance',   icon: ICONS.finance },
  { section: 'WORK' },
  { label:'Projects',  path:'/projects',  icon: ICONS.projects },
  { label:'Calendar',  path:'/calendar',  icon: ICONS.calendar },
  { label:'Analytics', path:'/analytics', icon: ICONS.analytics },
  { section: 'PEOPLE' },
  { label:'Team',      path:'/team',      icon: ICONS.team },
  { section: 'STORAGE' },
  { label:'Files',     path:'/files',     icon: ICONS.files },
];

/* Bottom bar shows these 4 -- everything else lives in the hamburger drawer */
const BOTTOM_NAV = [
  { label:'Home',    path:'/dashboard', icon: ICONS.dashboard },
  { label:'Leads',    path:'/leads',     icon: ICONS.leads },
  { label:'Clients',  path:'/clients',   icon: ICONS.clients },
  { label:'Finance',  path:'/finance',   icon: ICONS.finance },
];

const ToolsIcon    = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/></svg>;
const SettingsIcon = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/></svg>;
const MenuIcon      = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="3" y1="6" x2="21" y2="6"/><line x1="3" y1="12" x2="21" y2="12"/><line x1="3" y1="18" x2="21" y2="18"/></svg>;
const CloseIcon     = () => <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;

function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 760);
  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth <= 760);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isMobile;
}

export default function Sidebar() {
  const navigate    = useNavigate();
  const location    = useLocation();
  const { theme }   = useTheme();
  const [showTools, setShowTools] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const isMobile = useIsMobile();

  const go = (path) => { navigate(path); setDrawerOpen(false); };

  if (isMobile) {
    return (
      <>
        {/* Mobile top hamburger trigger */}
        <button className="sb-mob-menu-btn" data-theme={theme} onClick={()=>setDrawerOpen(true)} aria-label="Open menu">
          <MenuIcon/>
        </button>

        {/* Slide-in drawer */}
        {drawerOpen && (
          <div className="sb-drawer-overlay" onClick={()=>setDrawerOpen(false)}>
            <div className="sb-drawer" data-theme={theme} onClick={e=>e.stopPropagation()}>
              <div className="sb-drawer-hd">
                <div className="sb-logo-row" onClick={()=>go('/dashboard')}>
                  <div className="sb-logo sb-logo--mark"><RyzenMark size={24}/></div>
                  <div className="sb-logo-text">RyzenOS</div>
                </div>
                <button className="sb-drawer-close" onClick={()=>setDrawerOpen(false)}><CloseIcon/></button>
              </div>
              <div className="sb-nav">
                {NAV.map((item, i) => {
                  if (item.section) return <div key={i} className="sb-section">{item.section}</div>;
                  const active = location.pathname === item.path;
                  return (
                    <div key={item.path} className={`sb-item${active?' active':''}`} onClick={()=>go(item.path)}>
                      <span className="sb-item-icon">{item.icon}</span>
                      <span className="sb-item-label">{item.label}</span>
                    </div>
                  );
                })}
              </div>
              <div className="sb-bottom">
                <div className="sb-item" onClick={()=>{setShowTools(true); setDrawerOpen(false);}}>
                  <span className="sb-item-icon"><ToolsIcon/></span>
                  <span className="sb-item-label">Tools</span>
                </div>
                <div className="sb-item" onClick={()=>go('/settings')}>
                  <span className="sb-item-icon"><SettingsIcon/></span>
                  <span className="sb-item-label">Settings</span>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Bottom tab bar */}
        <div className="sb-bottombar" data-theme={theme}>
          {BOTTOM_NAV.map(item => {
            const active = location.pathname === item.path;
            return (
              <div key={item.path} className={`sb-bottombar-item${active?' active':''}`} onClick={()=>go(item.path)}>
                <span className="sb-bottombar-icon">{item.icon}</span>
                <span className="sb-bottombar-label">{item.label}</span>
              </div>
            );
          })}
          <div className="sb-bottombar-item" onClick={()=>setDrawerOpen(true)}>
            <span className="sb-bottombar-icon"><MenuIcon/></span>
            <span className="sb-bottombar-label">More</span>
          </div>
        </div>

        {showTools && <ToolsPanel onClose={()=>setShowTools(false)}/>}
      </>
    );
  }

  /* Desktop sidebar -- unchanged */
  return (
    <>
      <div className="sb" data-theme={theme}>
        <div className="sb-logo-row" onClick={()=>navigate('/dashboard')}>
          <div className="sb-logo sb-logo--mark"><RyzenMark size={24}/></div>
          <div className="sb-logo-text">RyzenOS</div>
        </div>
        <div className="sb-version">v2.4.13</div>

        <div className="sb-nav">
          {NAV.map((item, i) => {
            if (item.section) return (
              <div key={i} className="sb-section">{item.section}</div>
            );
            const active = location.pathname === item.path;
            return (
              <div key={item.path} className={`sb-item${active?' active':''}`} onClick={()=>navigate(item.path)}>
                <span className="sb-item-icon">{item.icon}</span>
                <span className="sb-item-label">{item.label}</span>
              </div>
            );
          })}
        </div>

        <div style={{flex:1}}/>

        <div className="sb-bottom">
          <div className="sb-item" onClick={()=>setShowTools(true)}>
            <span className="sb-item-icon"><ToolsIcon/></span>
            <span className="sb-item-label">Tools</span>
          </div>
          <div className="sb-item" onClick={()=>navigate('/settings')}>
            <span className="sb-item-icon"><SettingsIcon/></span>
            <span className="sb-item-label">Settings</span>
          </div>
        </div>
      </div>
      {showTools && <ToolsPanel onClose={()=>setShowTools(false)}/>}
    </>
  );
}
